import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "normalize.css";
import "antd/dist/antd.min.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { HashRouter } from "react-router-dom";
import { CartProvider } from "./components/Context/CartContext";
import { WishListProvider } from "./components/Context/WishListContext";
import { UserProvider } from "./components/Context/UserContext";
import ScrollToTop from "./ScrollToTop";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <HashRouter>
      <UserProvider>
        <CartProvider>
          <WishListProvider>
            <ScrollToTop />
            <App />
          </WishListProvider>
        </CartProvider>
      </UserProvider>
    </HashRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
